import { unauthenticatedAPIList } from './constants'
import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberFromString
} from 'libphonenumber-js/max'

const getCountryAndCallingCode = getCountries().map((country) => ({
  countryCode: country,
  callingCode: getCountryCallingCode(country),
  callingCodeLabel: '+' + getCountryCallingCode(country)
}))

export const getSortedCountries = () => {
  if (getCountryAndCallingCode) {
    return getCountryAndCallingCode.sort(
      (a, b) => Number(a.callingCode) - Number(b.callingCode)
    )
  }
  return []
}

export const verifyPhoneNumber = (number, countryCode) => {
  if (number && countryCode) {
    try {
      const phone = parsePhoneNumberFromString(number, countryCode)

      if (phone) {
        return phone.isValid()
      }
      return false
    } catch (e) {
      console.log(e)
      return false
    }
  }
  return false
}

export const dateFormatterTable = (date) => {
  if (date) {
    const [year, month, day] = date.split('-')
    const months = {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December'
    }
    return `${months[month]} ${day}, ${year}`
  } else {
    return ''
  }
}

export const isUnauthenticatedAPI = (url) => {
  if (url) {
    return unauthenticatedAPIList.some((api) => {
      return url.includes(api)
    })
  }
  return false
}

export const capitalizeFirstLetter = (str) => {
  if (str && str.length > 1) {
    return str.slice(0, 1).toString().toUpperCase() + str.slice(1, str.length)
  }
  return ''
}

export const getInitials = (str) => {
  if (str && str.length > 1) {
    const arr = str.split(' ')
    if (arr && arr.length > 1) {
      return (
        arr[0].slice(0, 1).toString().toUpperCase() +
        arr[1].slice(0, 1).toString().toUpperCase()
      )
    } else if (arr && arr.length === 1) {
      return arr[0].slice(0, 1).toString().toUpperCase()
    }
  }
  return ''
}

export default {
  dateFormatterTable,
  isUnauthenticatedAPI,
  capitalizeFirstLetter,
  getInitials,
  getSortedCountries,
  verifyPhoneNumber
}
